import { createFileRoute } from '@tanstack/react-router'
import { BriefingsSection } from '~/components/marketing/briefings-section'
import { CrmSection } from '~/components/marketing/crm-section'
import { MarketingShell } from '~/components/marketing/marketing-shell'
import { ProposalsSection } from '~/components/marketing/proposals-section'
import { marketingPageHead } from '~/lib/site-meta'

const PAGE_TITLE = 'Funil de clientes — CRM, briefings e propostas | Planno'
const PAGE_DESCRIPTION =
  'Pipeline de leads, briefings de intake configuráveis e propostas com link público. O funil inteiro do escritório de arquitetura, em um só lugar.'

export const Route = createFileRoute('/recursos/funil')({
  component: FunnelPage,
  head: () =>
    marketingPageHead({
      description: PAGE_DESCRIPTION,
      locale: 'pt-BR',
      path: '/recursos/funil',
      title: PAGE_TITLE,
    }),
})

function FunnelPage() {
  return (
    <MarketingShell>
      <CrmSection headingLevel="h1" />
      <BriefingsSection />
      <ProposalsSection />
    </MarketingShell>
  )
}
